import { Offer } from 'models/offer.model';
import { FormControl } from '@angular/forms';
import { OfferViewDTO } from './offer-view-dto.type';

export type InsuranceItemControls = {
  id: FormControl;
  itemsNature: FormControl;
  quotationRequired: FormControl;
  insuranceRate: FormControl;
  pricingRate: FormControl;
  maxValue: FormControl;
  basePricing: FormControl;
  position: FormControl;
  offer: FormControl;
};

export class GlobalInsurance {
  public insuranceChoice?: string;
  public itemNature?: string;
  public maxValue?: number;
  public basePricing?: number;
  public insuranceRate?: number;
  public pricingRate?: number;
  public offers?: OfferViewDTO[];
  public notifyOneByOneActivated?: boolean;
  public monthlyReportActivated?: boolean;
  public warningAmount?: number;
}

export class InsuranceItem {
  public id?: number;
  public itemsNature!: string;
  public quotationRequired: boolean = false;
  public insuranceRate?: number;
  public pricingRate?: number;
  public maxValue?: number;
  public basePricing?: number;
  public position?: number;
  public offer: Offer;
  public notifyOneByOneActivated?: boolean;
  public monthlyReportActivated?: boolean;
  public warningAmount?: number;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.offer = new Offer(data.offer);
  }

  public serialize(): any {
    return {
      id: this.id,
      itemsNature: this.itemsNature,
      quotationRequired: this.quotationRequired,
      insuranceRate: this.insuranceRate,
      pricingRate: this.pricingRate,
      maxValue: this.maxValue,
      basePricing: this.basePricing,
      position: this.position,
      offer: this.offer.serialize(),
      notifyOneByOneActivated: this.notifyOneByOneActivated,
      monthlyReportActivated: this.monthlyReportActivated,
      warningAmount: this.warningAmount,
    };
  }
}
